import { BaseService } from './base.service'
import { ErrorWrapper, ResponseWrapper } from './util'
import storeHelper from '@/store/helper'

import FileDownload from 'js-file-download'
import moment from 'moment'

export class CalendarService extends BaseService {
  static async getCalendarByUser(body) {
    try {
      const response = await this.request({ auth: true }).post(
        storeHelper.getUrl('cnps.wkcldr.get-list-task-by-userid'),
        body
      )
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      console.log(error)
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }

  static async upsert(params = {}) {
    try {
      const response = await this.request({ auth: true }).post(
        storeHelper.getUrl('cnps.wkcldr.upsert-wkcldr'),
        params
      )
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }

  static async createLead(params = {}) {
    try {
      const response = await this.request({ auth: true }).post(
        storeHelper.getUrl('cnps.lead.action-create-v2'),
        params
      )
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }
  static async updateLead(params = {}) {
    try {
      const response = await this.request({ auth: true }).post(
        storeHelper.getUrl('cnps.lead.action-update'),
        params
      )
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }

  static async cancelWork(params = {}) {
    try {
      const response = await this.request({ auth: true }).post(
        storeHelper.getUrl('cnps.wkcldr.delete'),
        params
      )
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }

  static async updateWorkResult(params = {}) {
    try {
      const response = await this.request({ auth: true }).post(
        storeHelper.getUrl('cnps.wkcldr.update-result'),
        params
      )
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }
  static async updateWorkResultLead(params = {}) {
    try {
      const response = await this.request({ auth: true }).post(
        storeHelper.getUrl('cnps.lead.complete-wk'),
        params
      )
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }

  static async export(params) {
    try {
      const response = await this.request({ auth: true }).post(
        storeHelper.getUrl('cnps.wkcldr.export-excel-general'),
        params,
        {
          responseType: 'blob',
        }
      )

      if (response.headers['content-type'] === 'application/json') {
        alert('Không có dữ liệu để tải xuống')
        return
      }
      FileDownload(
        response.data,
        'Calendar-work' + ' ' + moment(new Date(new Date())).format('DD/MM/YYYY') + '.xlsx'
      )
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      console.log(error)
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }

  static async exportExcel(params) {
    try {
      const response = await this.request({ auth: true }).post(
        storeHelper.getUrl('cnps.wkcldr.export-excel-wkcldr'),
        params,
        {
          responseType: 'blob',
        }
      )

      if (response.headers['content-type'] === 'application/json') {
        alert('Không có dữ liệu để tải xuống')
        return
      }
      FileDownload(
        response.data,
        'Export_Congviec' + '_' + moment(new Date(new Date())).format('DD/MM/YYYY') + '.xlsx'
      )
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      console.log(error)
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }

  static async getById(params = {}) {
    try {
      const response = await this.request({ auth: true }).post(
        storeHelper.getUrl('cnps.wkcldr.get-detail-task-by-id'),
        params
      )
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }

  static async exportExcelCVKD(params) {
    try {
      const response = await this.request({ auth: true }).post(
        storeHelper.getUrl('cnps.summary.sale-work-xls'),
        params,
        {
          responseType: 'blob',
        }
      )
      if (response.headers['content-type'] === 'application/json') {
        alert('Không có dữ liệu để tải xuống')
      } else {
        FileDownload(
          response.data,
          'Statistic_Work_CVKD' + ' ' + moment(new Date(new Date())).format('DD/MM/YYYY') + '.xlsx'
        )
      }
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      console.log(error)
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }

  static async downloadFileTemplate(params = {}) {
    try {
      const response = await this.request({ auth: true }).post(
        storeHelper.getUrl('cnps.wkcldr.import-template'),
        params,
        {
          responseType: 'blob',
        }
      )
      console.log(response)
      if (response.headers['content-type'] === 'application/json') {
        alert('Không có dữ liệu để tải xuống hoặc bạn không có quyền')
        return
      }
      FileDownload(
        response.data,
        'Import_Calendar_Template' +
          '_' +
          moment(new Date(new Date())).format('DD/MM/YYYY') +
          '.xlsx'
      )
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }

  static async importCalendarByExcel(params) {
    try {
      const response = await this.request({ auth: true }).post(
        storeHelper.getUrl('cnps.wkcldr.import-data'),
        params
      )
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }

  static async historyUpload(params) {
    try {
      const response = await this.request({ auth: true }).post(
        storeHelper.getUrl('cnps.wkcldr.history-import-wkcldr'),
        params
      )
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }
}
